<template>
  <div class="py-4 container-fluid">
    <div class="row py-5">
        <div class="col-12 col-md-3 col-sm-12">
            <div>
                <div class="card text-black-50 mb-3" style="width: 300px;background-color: rgb(150 150 181);">
                    <div class="card-header text-center justify-content-center align-content-center fs-3">Users</div>
                    <div class="card-body">
                        <p class="card-text display-3 font-weight-bolder text-center fs-2">{{this.users}}</p>
                    </div>
                </div>
              </div>
        </div>
        <div class="col-12 col-md-3 offset-md-1 col-sm-12">
            <div>
            <div class="card text-black-50 mb-3" style="width: 300px;background-color: rgb(150 150 181);">
                <div class="card-header text-center justify-content-center align-content-center fs-3">Subscriptions</div>
                <div class="card-body">
                    <p class="card-text display-3 font-weight-bolder text-center fs-2">{{this.subscriptions}}</p>
                </div>
            </div>
            </div>
        </div>
        <div class="col-12 col-md-4 offset-md-1 col-sm-12">
            <div>
            <div class="card text-black-50 mb-3"  style="width: 300px;background-color: rgb(150 150 181);">
                <div class="card-header text-center justify-content-center align-content-center fs-3">Orders</div>
                <div class="card-body">
                    <p class="card-text display-3 font-weight-bolder text-center fs-2">{{this.orders}}</p>
                </div>
            </div>
            </div>
        </div>
    </div>
    <div class="row py-5">
        <div class="col-12 col-md-3 col-sm-12">
            <div>
                <div class="card text-black-50 mb-3" style="width: 300px;background-color: rgb(150 150 181);">
                    <div class="card-header text-center justify-content-center align-content-center fs-3">Facebook</div>
                    <div class="card-body">
                        <p class="card-text display-3 font-weight-bolder text-center fs-2">{{this.facebook}}</p>
                    </div>
                </div>
              </div>
        </div>
        <div class="col-12 col-md-3 offset-md-1 col-sm-12">
            <div>
            <div class="card text-black-50 mb-3" style="width: 300px;background-color: rgb(150 150 181);">
                <div class="card-header text-center justify-content-center align-content-center fs-3">Instagram</div>
                <div class="card-body">
                    <p class="card-text display-3 font-weight-bolder text-center fs-2">{{this.instagram}}</p>
                </div>
            </div>
            </div>
        </div>
        <div class="col-12 col-md-4 offset-md-1 col-sm-12">
            <div>
            <div class="card text-black-50 mb-3"  style="width: 300px;background-color: rgb(150 150 181);">
                <div class="card-header text-center justify-content-center align-content-center fs-3">Whatsapp</div>
                <div class="card-body">
                    <p class="card-text display-3 font-weight-bolder text-center fs-2">{{this.whatsapp}}</p>
                </div>
            </div>
            </div>
        </div>
        </div>
        </div>
</template>
<script>
import AdminService from './service/AdminService'
export default {
  name: "dashboard",
  data() {
    return {
      adminService : null ,
      users : null ,
      facebook : null ,
      instagram : null ,
      whatsapp : null ,
      orders : null ,
      subscriptions : null 
    };
  },
  created(){
    this.adminService = new AdminService()
  },
  mounted(){
    this.adminService.getStatisctics().then((data)=>{
      console.log(data);
      this.users = data.users ;
      this.facebook = data.facebook ;
      this.instagram = data.instagram;
      this.whatsapp = data.whatsapp ;
      this.orders = data.orders ;
      this.subscriptions = data.subscriptions
    })
  }
};
</script>
